import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ViewNotes from "./ViewNotes";
import ViewExpandedNote from "./ViewExpandedNote";

const StudentNotesRouter = () => {
  return (
    <Routes>
      <Route index element={<ViewNotes />} />
      <Route path="share-note/:id" element={<ViewExpandedNote />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default StudentNotesRouter;
